module.exports = __webpack_public_path__ + "static/media/gls.fe21a778.png";